export var DatepickerConfig = {
  drops: 'down',
  format: 'YYYY-MM-DD',
  locale: 'en',
  enableMonthSelector: 'true',
  multipleYearsNavigateBy: 10
};






// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/shared/custom-service/datepicker-configuration.service.ts